// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ivy-masthead .menu-bar a[aria-label=true] {
  pointer-events: none;
  color: #e7e0dd !important;
}`, "",{"version":3,"sources":["webpack://./src/app/common/header/headercomponent/header.component.scss"],"names":[],"mappings":"AAAA;EACC,oBAAA;EACA,yBAAA;AACD","sourcesContent":[".ivy-masthead .menu-bar a[aria-label=\"true\"] {\n\tpointer-events: none;\n\tcolor: #e7e0dd !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
